import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import Order from '../../../smoothr-web-app-core/models/Order';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { environment } from '../../../environments/environment';
import { numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';
import { NavigationService } from 'src/app/services/navigation.service';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { AskToCreateAccountModalComponent } from '../ask-to-create-account-modal/ask-to-create-account-modal.component';
import { ModalController } from '@ionic/angular';
import { SignInModalComponent } from '../sign-in-modal/sign-in-modal.component';
import { SignUpModalComponent } from '../sign-up-modal/sign-up-modal.component';

@Component({
	selector: 'app-to-order-button',
	templateUrl: './to-order-button.component.html',
	styleUrls: ['to-order-button.component.scss'],
})
export class ToOrderButtonComponent {
	@Input() order: Order;

	constructor(
		private router: Router,
		private navigationService: NavigationService,
		private repositoryService: RepositoryService,
		private modalCtrl: ModalController
	) {}

	get price(): number {
		if (!this.order) {
			return 0;
		}
		return OrderUtils.articleGroupsTotalPrice(
			this.order.orderedArticles,
			this.order.type,
			this.order.preorder.type,
			this.order.terminalorder ? this.order.terminalorder.type : null
		);
	}

	get formattedPrice(): string {
		return numberToCurrency(this.price, this.order.currency);
	}

	get active(): boolean {
		return this.price > 0;
	}

	async goToOrder() {
		if (this.active) {
			//
			if (this.repositoryService?.customer?.isAnonymous) {
				// const result = await AskToCreateAccountModalComponent.show(this.modalCtrl);
				// if (result === 'sign_in') {
				// 	this.signIn();
				// 	return;
				// }
				// if (result === 'sign_up') {
				// 	this.signUp();
				// 	return;
				// }
				await this.navigationService.order();
			} else {
				await this.navigationService.order();
			}
		}
	}
	async signIn() {
		try {
			await this.modalCtrl.dismiss();
		} catch (e) {}
		const result = await SignInModalComponent.show(this.modalCtrl);
		if (result === 'sign-up') {
			this.signUp();
		}
	}
	async signUp() {
		try {
			await this.modalCtrl.dismiss();
		} catch (e) {}
		const result = await SignUpModalComponent.show(this.modalCtrl);
	}
}
